// extracted by mini-css-extract-plugin
export default {"list":"PalletsTransferHistoryActionBody_list__ZFmW5","moreButton":"PalletsTransferHistoryActionBody_moreButton__fHL20"};